import React, { useContext } from "react";
import { Pressable } from "react-native";
import { Image } from "../../shared";
import { NavigationContext } from "../../../providers";
import { AdvancedCarouselSlide } from "./AdvancedCarouselSlide";
export const CarouselSlide = ({ slide, widthConstraint, isAdvanced, ...props }) => {
    const { onNavigateToItem } = useContext(NavigationContext);
    if (isAdvanced) {
        return (React.createElement(AdvancedCarouselSlide, { slide: slide, widthConstraint: widthConstraint, ...props }));
    }
    return (React.createElement(Pressable, { onPress: () => onNavigateToItem(slide) },
        React.createElement(Image, { uri: slide?.cover?.src || "", widthConstraint: widthConstraint, style: {
                borderRadius: 0,
                marginBottom: 0,
            }, ...props })));
};
//# sourceMappingURL=CarouselSlide.js.map